export default __webpack_public_path__ + "static/media/notFoundImage.4579f249.jpg";